import { useEffect } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { useLifely } from '../../context/LifelyContext';
import { setTokenProvider } from '../../services/api';

export default function ClerkAuthBridge() {
  const { isSignedIn, getToken } = useAuth();
  const { user: clerkUser } = useUser();
  const { login, logout, isAuthenticated, setTokenProviderReady } = useLifely();

  useEffect(() => {
    setTokenProvider(() => getToken({ template: 'lifely' }).then(t => t || getToken()));
    setTokenProviderReady(true);
  }, [getToken, setTokenProviderReady]);

  useEffect(() => {
    if (isSignedIn && !isAuthenticated) {
      (async () => {
        let token = await getToken({ template: 'lifely' });
        if (!token) token = await getToken();
        if (!token) return;
        console.log('Clerk token prefix:', token?.substring(0, 20));
        await login(token);
      })();
    } else if (isSignedIn === false && isAuthenticated) {
      logout();
    }
  }, [isSignedIn, isAuthenticated, getToken, login, logout]);

  return null;
}
